













































import { Vue, Component } from 'vue-property-decorator';
import AppModule from '@/store/modules/app';
import LifecycleModule from '@/store/modules/lifecycle';
import { UserApi } from '@compassdigital/foodworks.ts.sdk';

import SiteLayout from '@/layout/fw/index.vue';
import Card from '@/components/Card/StandardCard/index.vue';
import Textfield from '@/components/Form/Textfield/index.vue';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';

@Component({
  beforeRouteEnter(to, from, next) {
    if (AppModule.isLoggedIn) {
      LifecycleModule.terminate();
    }
    next();
  },
  components: {
    SiteLayout,
    Card,
    Textfield,
    PrimaryButton,
  },
})
export default class ForgotPassword extends Vue {
  private email: string = '';

  private error: string = '';

  private loading: boolean = false;

  emailRules = [
    (v: any) => !!v || 'E-mail is required for users to access their account',
    (v: any) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v.trim())
      || 'E-mail must be valid',
  ];

  public async onEmailSendLink() {
    if ((this.$refs.form as any).validate()) {
      try {
        this.loading = true;
        const userApi = new UserApi(AppModule.apiConfig);
        await userApi.forgotPassword({ email: this.email });
        try {
          const message = `A password reset link has been sent to ${
            this.email
          }`;
          this.$router.push({ name: 'login', params: { message } });
        } catch (err) {
          throw err;
        }
      } catch (err) {
        if (err.response.data.error.message) {
          this.error = err.response.data.error.message;
        }
      }
      this.loading = false;
    }
  }
}
